import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import AppShell from "@/components/AppShell";
import { fetchFamily } from "@/lib/api";

export default function AppLayout() {
  const [family, setFamily] = useState(null);
  const [children, setChildren] = useState([]);

  const load = () => fetchFamily().then(d => { setFamily(d.family); setChildren(d.children || []); });
  useEffect(() => { load(); }, []);

  return (
    <AppShell family={family} children={children} pageChildren={<Outlet context={{ family, children, reloadFamily: load }} />} />
  );
}
